export default __webpack_public_path__ + "static/media/7.2.bd3bb155.mp4";